import { Navigate, Outlet, useLocation } from 'react-router-dom';
import React, { useState } from 'react';
import AdminNavbar from '../components/AdminNavbar';
import useAuth from '../hooks/useAuth';
import FeedbackView from '../components/FeedbackView';

function AdminLayout() {
  const auth = useAuth();
  const { pathname } = useLocation();

  const [showFeedback, setShowFeedback] = useState(false);

  const handleFeedbackShow = () => setShowFeedback(true);
  const handleFeedbackClose = () => setShowFeedback(false);

  if (auth.isAdminAuth() || auth.isOrgAdminAuth()) {
    return (
      <>
        <AdminNavbar onFeedbackShow={handleFeedbackShow} />
        <div className="container-fluid">
          <div className="row">
            <main className="col-md-12 ms-sm-auto col-lg-12 px-md-4">
              <Outlet />
            </main>
          </div>
        </div>
        <FeedbackView show={showFeedback} onClose={handleFeedbackClose} />
     
      </>
    );
  }

  return <Navigate to={`/login?redirect=${encodeURIComponent(pathname)}`} replace />;
}

export default AdminLayout;
